<template>
  <v-container py-0>
    <v-layout row wrap justify-center>
      <v-flex md10 xs12 px-2>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $t('fields.global.types.league') }}
            </v-toolbar-title>
            <v-spacer />
            <v-dialog v-model="dialog" lazy max-width="800px">
              <template #activator="{ on }">
                <v-btn flat class="mb-2" v-on="on" @click="openDialog">
                  {{ $t('action.buttons.add') }}
                </v-btn>
              </template>
              <v-card>
                <v-toolbar flat dense color="primary" dark>
                  <v-toolbar-title>
                    {{ $tc('models.category', 2) }}
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 px-2>
                      <category-menu
                        v-model="categoryId"
                        v-validate="'required'"
                        clearable
                        :label="
                          $t('action.actions.select', {
                            field: $tc('models.category'),
                          })
                        "
                        :data-vv-name="$tc('models.category')"
                        :error-messages="errors.collect($tc('models.category'))"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <meta-button type="cancel" @click="dialog = false" />
                  <meta-button
                    type="add"
                    :loading="loading"
                    @click="addCategory"
                  />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="team.allCategories"
              disable-initial-sort
              :loading="loading"
              :rows-per-page-items="[5, 10]"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center px-0" style="width: 50px">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-icon
                        color="error"
                        class="cursor"
                        v-on="on"
                        @click="deleteCategory(props.item._id)"
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>{{ $t('action.buttons.delete') }}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-center">
                  {{ props.item.yearStart }}
                </td>
                <td>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span>{{ props.item.mainName }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </td>
                <td class="text-xs-center" style="min-width: 350px">
                  <template
                    v-for="(category, index) in props.item.categoryName"
                  >
                    <v-chip :key="index" small color="primary" dark>
                      {{ category }}
                    </v-chip>
                  </template>
                </td>
                <td class="text-xs-center">
                  {{ formatDate(props.item.createdAtMs) }}
                </td>
                <td class="text-xs-center">
                  {{ formatDate(props.item.expiredAtMs) }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import CategoryMenu from '@/components/management/categories/CategoryMenu'

export default {
  name: 'TabCategories',
  components: { CategoryMenu },
  /* props: {
    team: {
      type: Object
    }
  }, */
  data() {
    return {
      categoryId: '',
      loading: false,
      dialog: false,
    }
  },
  computed: {
    ...mapState({
      team: (state) => state.teams.selected,
    }),
    headers() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.global.season'),
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('fields.global.name'),
          sortable: false,
        },
        {
          text: this.$t('fields.global.types.league'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.global.createdDate'),
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('titles.global.expiredDate'),
          sortable: false,
          align: 'center',
        },
      ]

      return headers
    },
    currentCategory() {
      return this.team.categories.length > 0
        ? this.team.categories[0]._id
        : null
    },
  },
  methods: {
    ...mapActions({
      setUpdate: 'teams/update',
      fetchOne: 'teams/fetchOne',
    }),
    openDialog() {
      this.categoryId = ''
      this.$validator.reset()
    },
    async addCategory() {
      try {
        const isValid = await this.validate()
        if (isValid) {
          this.loading = true
          let categories = this.team.categories.map((item) => item._id)
          let payload = {
            _id: this.team._id,
            categoryId: [...categories, this.categoryId],
          }
          await this.setUpdate(payload)
          this.dialog = false
          await this.fetchOne(this.team._id)
        }
      } finally {
        this.loading = false
      }
    },
    async deleteCategory(_id) {
      if (confirm(this.$t('titles.global.confirmDelete'))) {
        try {
          this.loading = true
          let categories = this.team.categories
            .map((item) => item._id)
            .filter((item) => item !== _id)
          let payload = {
            _id: this.team._id,
            categoryId: categories,
          }
          await this.setUpdate(payload)
          await this.fetchOne(this.team._id)
        } finally {
          this.loading = false
        }
      }
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY')
    },
  },
}
</script>
